import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/AppRouter";
import axios from "axios";
import "./index.css";

// Importuj pojmenované komponenty
import {
  BButton,
  BCard,
  BTable,
  BFormInput,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
  BNavItemDropdown,
  BForm,
} from "bootstrap-vue-next";

const app = createApp(App);

// API Base URL konfigurace
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "" // Stejný origin v production
    : "http://localhost:8000"; // Django dev server

// Axios setup s base URL a autentizací
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.withCredentials = true;

// Interceptor pro přidání JWT tokenu
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor pro refresh token při 401
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (!originalRequest) {
      return Promise.reject(error);
    }

    // Check if the error is from token endpoints to prevent loop
    const isTokenUrl = originalRequest.url && (
      originalRequest.url.includes("/api/token/") || 
      originalRequest.url.includes("/token")
    );

    if (error.response?.status === 401 && !originalRequest._retry && !isTokenUrl) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refresh_token");
      if (!refreshToken) {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        router.push("/login");
        return Promise.reject(error);
      }
      try {
        const response = await axios.post("/api/token/refresh/", {
          refresh: refreshToken,
        });
        localStorage.setItem("access_token", response.data.access);
        originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
        return axios(originalRequest);
      } catch (refreshError) {
        // Refresh selhal (neplatný/expirovaný token) - odhlásit
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        router.push("/login");
        return Promise.reject(refreshError);
      }
    }

    // Pokud selže samotný refresh token (400 nebo 401), odhlásit uživatele
    if (isTokenUrl && originalRequest.url.includes("/refresh/") && (error.response?.status === 400 || error.response?.status === 401)) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      router.push("/login");
    }

    return Promise.reject(error);
  }
);

app.config.globalProperties.$http = axios;
app.config.globalProperties.$api = API_BASE_URL;

// Router
app.use(router);

// Registrace komponent
app.component("BButton", BButton);
app.component("BCard", BCard);
app.component("BTable", BTable);
app.component("BFormInput", BFormInput);
app.component("BForm", BForm);
app.component("BNavbar", BNavbar);
app.component("BNavbarBrand", BNavbarBrand);
app.component("BNavbarNav", BNavbarNav);
app.component("BNavItemDropdown", BNavItemDropdown);

app.mount("#app");
